import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
class SessionAPI {
    constructor() {
        this.infoRequest = (servicesApi, defaultRequestParams) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/me`,
                params: defaultRequestParams,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new SessionAPI();
